import React from "react";

export default function GuestUserForm({
  userName,
  setUserName,
  userEmail,
  setUserEmail,
  userDob,
  setUserDob,
  contactNumber,
  setContactNumber,
  nameError,
  setNameError,
  emailError,
  setEmailError,
  dobError,
  setDobError,
  contactError,
  setContactError,
  minAdultDobIso,
  isValidEmail,
  isValidDob,
  dobInputRef,
  openDobPicker,
}) {
  return (
    <div className="review-user-form">
      <h4 className="review-user-title">Guest User Details</h4>
      <div className="review-user-field">
        <label htmlFor="reviewUserName">User Name</label>
        <input
          id="reviewUserName"
          type="text"
          value={userName}
          onChange={(e) => {
            setUserName(e.target.value);
            if (nameError) setNameError("");
          }}
          onBlur={() => {
            if (!String(userName || "").trim()) setNameError("User name is required.");
          }}
          placeholder="Enter user name"
        />
        {nameError ? <span className="review-field-error">{nameError}</span> : null}
      </div>
      <div className="review-user-field">
        <label htmlFor="reviewUserEmail">User Email</label>
        <input
          id="reviewUserEmail"
          type="email"
          value={userEmail}
          onChange={(e) => {
            setUserEmail(e.target.value);
            if (emailError) setEmailError("");
          }}
          onBlur={() => {
            const v = String(userEmail || "").trim();
            if (!v) setEmailError("User email is required.");
            else if (!isValidEmail(v)) setEmailError("Please enter a valid email address.");
          }}
          placeholder="Enter user email"
        />
        {emailError ? <span className="review-field-error">{emailError}</span> : null}
      </div>
      <div className="review-user-field">
        <label htmlFor="reviewUserDob">Date of Birth</label>
        <input
          ref={dobInputRef}
          id="reviewUserDob"
          type="date"
          max={minAdultDobIso}
          value={userDob}
          onPointerDown={openDobPicker}
          onClick={openDobPicker}
          onChange={(e) => {
            setUserDob(e.target.value);
            if (dobError) setDobError("");
          }}
          onBlur={() => {
            const v = String(userDob || "").trim();
            if (!v) setDobError("Date of birth is required.");
            else if (!isValidDob(v)) setDobError("User must be at least 18 years old.");
          }}
        />
        {dobError ? <span className="review-field-error">{dobError}</span> : null}
      </div>
      <div className="review-user-field">
        <label htmlFor="reviewContactNumber">Contact Number</label>
        <input
          id="reviewContactNumber"
          type="tel"
          inputMode="numeric"
          pattern="^\+1\s\(\d{3}\)\s\d{3}-\d{4}$"
          value={contactNumber}
          onChange={(e) => {
            setContactNumber(e.target.value);
            if (contactError) setContactError("");
          }}
          onBlur={() => {
            if (!String(contactNumber || "").trim()) setContactError("Contact number is required.");
          }}
          placeholder="+1 (443) 432-4324"
        />
        {contactError ? <span className="review-field-error">{contactError}</span> : null}
      </div>
    </div>
  );
}
